import React from 'react'
import Head from 'next/head'
import Pitch from '@src/components/DisposalPage/Pitch'
import FeatureList from '@src/components/DisposalPage/FeatureList'
import Approach from '@src/components/DisposalPage/Approach'
import FAQ from '@src/components/DisposalPage/FAQ'
import SustainabilityDashboardPromo from '@src/components/DisposalPage/SustainabilityDashboardPromo'
import SchemaMarkup from '@src/components/SchemaMarkup'
import RelatedServices from '@src/components/RelatedServices'
import Clients from '@src/pages/LandingPage/Clients'
import Testimonials from '@src/pages/LandingPage/Testimonials'
import junkTestimonials from '@src/constants/junkTestimonials'
import TrustBox from '@src/pages/common/components/TrustBox'
import TrustedByClients from '@src/components/DisposalPage/TrustedByClients'
import pageClasses from '@src/styles/junk-removal-page.module.css'
// eslint-disable-next-line import/extensions
import furniture from '../../json/furniture-removal-data.json'

const furnitureServiceData = {
  name: 'Furniture Removal',
  description:
    'Affordable furniture removal for homes and businesses nationwide. Dimension hauls sofas, chairs, beds, dressers, and office furniture, prioritizing donation and recycling, with pricing by the piece.',
  serviceType: 'Furniture Removal',
  url: 'https://getdimension.com/furniture-removal',
  provider: {
    name: 'Dimension',
    url: 'https://getdimension.com',
    address: {
      streetAddress: '2261 Market Street, #4061',
      addressLocality: 'San Francisco',
      addressRegion: 'CA',
      postalCode: '94114',
      addressCountry: 'US',
    },
    telephone: '+1 (415) 340-7182',
  },
  offers: [
    { name: 'Sofa and Couch Removal' },
    { name: 'Bed and Dresser Removal' },
    { name: 'Office Furniture Removal' },
    { name: 'Furniture Donation and Recycling' },
    { name: 'On-Site Furniture Disassembly' },
  ],
}

const furnitureFAQData = {
  questions: furniture.FAQContent.contentList.map((faq) => ({
    question: faq.heading.replace(/<[^>]*>/g, ''),
    answer: faq.textList.join(' '),
  })),
}

function FurnitureRemoval() {
  return (
    <>
      <Head>
        <title>Furniture Removal &amp; Disposal Services | Dimension</title>
        <meta
          name="description"
          content="Cheap furniture removal for homes and offices nationwide. Dimension hauls sofas, beds, desks, and bulky furniture, prioritizing donation and recycling, with pricing by the piece from around $79."
        />
        <meta name="viewport" content="width=device-width, initial-scale=1" />
        <link rel="canonical" href="https://getdimension.com/furniture-removal" />
        <SchemaMarkup type="WebSite" />
        <SchemaMarkup type="Service" data={furnitureServiceData} />
        <SchemaMarkup type="FAQPage" data={furnitureFAQData} />
        <SchemaMarkup type="LocalBusiness" />
      </Head>
      <div className={pageClasses.root}>
        <Pitch
          variant="hazardous-waste"
          heroImage="junk"
          heading={furniture.pitch.heading}
          material={furniture.pitch.material}
          pitchText={furniture.pitch.pitchText}
          ctaLink={furniture.pitch.ctaLink}
          ctaText={furniture.pitch.ctaText}
          belowCta={<TrustBox isMobile isDark={false} />}
          belowPitch={<TrustedByClients />}
        />
        <Testimonials testimonials={junkTestimonials} />
        <Clients />
        <FeatureList {...furniture.solutions} />
        <SustainabilityDashboardPromo />
        <FeatureList {...furniture.benefits} />
        <Approach {...furniture.approach} />
        <FAQ {...furniture.FAQContent} />
        <RelatedServices
          services={[
            {
              label: 'Mattress Removal',
              href: '/mattress-removal',
              description:
                'Cheap mattress and bed-set disposal with recycling of steel, foam, and fiber.',
            },
            {
              label: 'Appliance Removal',
              href: '/appliance-removal',
              description:
                'Pickup and metal recycling of refrigerators, washers, ovens, and other appliances.',
            },
            {
              label: 'Piano Removal',
              href: '/piano-removal',
              description:
                'Safe removal and recycling of uprights and grand pianos by an equipped crew.',
            },
            {
              label: 'Junk Removal',
              href: '/junk-removal',
              description:
                'Full-service junk hauling and whole-home or office cleanouts, priced by volume.',
            },
          ]}
        />
      </div>
    </>
  )
}

export default FurnitureRemoval
